// Convenio MLC 2006, paso 1 (SeleccionarPuerto): validación de campos previa a la consulta Atenea.
// Devuelve la key del mensaje de error (locales/{es,en}.json) o '' cuando todo es válido.
export function validarPasoSeleccionar(puerto, omi, fecha, tomorrow) {
    if (puerto === '0' || fecha === '') return 'faltanCampos';
    if (omi === '') return 'mensajeOMIVacio';
    if (omi.length > 7) return 'errorLongitudOMI';
    if (fecha < tomorrow) return 'errorFechaRecalada';
    return '';
}
